<template>
  <div v-if="filteredFiles.length > 1">
    <div class="prev" @click.prevent="prev">
      <chevron-left-icon size="40"></chevron-left-icon>
    </div>

    <div class="next" @click.prevent="next">
      <chevron-right-icon size="40"></chevron-right-icon>
    </div>
  </div>
</template>

<script>
import { events } from '@main/js/bus'
import { mapGetters } from 'vuex'
import { ChevronLeftIcon, ChevronRightIcon } from 'vue-feather-icons'
export default {
  name: 'FilePreviewActions',
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
  },
  computed: {
    ...mapGetters(['fileInfoDetail', 'data', 'dataPreview']),

    filteredFiles() {
      if (!this.fileInfoDetail || !this.fileInfoDetail[0]) return []
      const t = this.fileInfoDetail[0].type
      const source =
        this.dataPreview && this.dataPreview.length
          ? this.dataPreview
          : this.data || []
      const filtered = []
      source.forEach((element) => {
        if (element && element.type === t) filtered.push(element)
      })
      return filtered
    },
  },

  methods: {
    next: function () {
      events.$emit('filePreviewAction:next')
    },
    prev: function () {
      events.$emit('filePreviewAction:prev')
    },
  },
}
</script>

<style lang="scss" scoped>
.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 52%;
  display: flex;
  justify-content: center;
  color: $color-light;
  border-radius: 50%;
  text-decoration: none;
  user-select: none;
  filter: drop-shadow(0px 1px 0 $shadow_element_color);
  padding: 10px;
}
.next {
  right: 0;
}
.prev {
  left: 0;
}
</style>
